<template>
  <div :class="bem({'is-loading': shopifyStore.loading})">
    <VisionHeading
      :class="[bem('title')]"
      tag="h2"
      size="h5"
      font-weight="light"
    >
      <span v-if="thresholdMetOnLoad || shopifyStore.hasFreeShippingDiscount">
        Upgrade your bag.
        <span :class="bem('title-highlight')">Free Shipping Included.</span>
      </span>
      <span v-else-if="freeShippingRemainingSpend > 0">
        Upgrade your bag. Spend
        <span :class="bem('title-highlight')">{{ $tcs(freeShippingRemainingSpend) }}</span> more and get
        <span :class="bem('title-highlight')">FREE Shipping.</span>
      </span>
      <span v-else>
        Upgrade your bag.
        <span :class="bem('title-highlight')">FREE shipping Included.</span>
      </span>
    </VisionHeading>
  </div>
</template>

<script setup lang="ts">
const bem = useBEM('UpsellsProgress')
const shopifyStore = useShopifyStore()

const thresholdMetOnLoad = ref<boolean>(false)

const freeShippingRemainingSpend = computed(() => {
  return shopifyStore.freeShippingPromo?.remainingSpend
})
</script>

<style lang="postcss">
.UpsellsProgress {
  @apply mb-4
  px-[var(--cart-inline-padding)] pr-[calc(var(--cart-inline-padding)_+_120px)]
  overflow-clip relative;

  &--is-loading {
    .UpsellsProgress__title {
      @apply translate-y-full
    }
  }
}

.UpsellsProgress__title {
  @apply text-black transition-transform duration-300;
}

.UpsellsProgress__title-highlight {
  @apply text-green;
}
</style>
